import React, { useEffect, useState } from 'react';
import {
  Skeleton, SkeletonBlock, SkeletonLine, SkeletonContent,
} from '@one-thd/sui-atomic-components';

const renderShape = (shape, index) => {
  const {
    type = 'block', contentProps, blockProps, lineProps,
  } = shape || {};

  return (
    <SkeletonContent key={index} {...contentProps}>
      {type === 'line'
        ? <SkeletonLine fullWidth {...lineProps} />
        : <SkeletonBlock aspect="wide" width="100%" {...blockProps} />}
    </SkeletonContent>
  );
};

export const withClientSideRender = (WrappedComponent, options = {}) => {
  const { placeholder } = options;
  // `placeholder: false` (or `null`) opts out of the Skeleton entirely, while
  // still skipping server-side rendering. Anything else (including omitted) falls
  // back to the default Skeleton block.
  const showPlaceholder = placeholder !== false && placeholder !== null;
  const {
    className,
    variant = 'block',
    skeletonProps,
    blockProps,
    lineProps,
    shapes,
  } = placeholder || {};

  const Wrapper = (props) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
    }, []);

    if (!mounted) {
      if (!showPlaceholder) {
        return null;
      }

      return (
        <Skeleton className={className} {...skeletonProps}>
          {Array.isArray(shapes) && shapes.length > 0
            ? shapes.map(renderShape)
            : (variant === 'line'
              ? <SkeletonLine fullWidth {...lineProps} />
              : <SkeletonBlock aspect="wide" width="100%" {...blockProps} />)}
        </Skeleton>
      );
    }

    return <WrappedComponent {...props} />;
  };
  Wrapper.dataModel = WrappedComponent.dataModel || {};
  Wrapper.wraps = { ...(WrappedComponent.wraps || {}), clientSideRender: true };
  Wrapper.$$typeof = WrappedComponent.$$typeof;
  Wrapper.displayName = WrappedComponent.displayName;

  return Wrapper;
};
